






import { computed, defineComponent, PropType } from "@vue/composition-api";

export interface Props {
  bold: boolean;
  required: boolean;
  color: string;
  background: string;
  size: string;
  customStyle: string;
}

export default defineComponent({
  name: "OccLabel",
  props: {
    required: {
      type: Boolean,
      default: false
    },
    bold: {
      type: Boolean,
      default: false
    },
    // TODO: 規定の値しか入力できないよう型定義する
    color: {
      type: String,
      default: ""
    },
    background: {
      type: String as PropType<"" | "blue-light" | "gray">,
      default: ""
    },
    size: {
      type: String,
      default: "medium"
    },
    customStyle: {
      type: String,
      default: ""
    }
  },
  setup(props: Props) {
    const classes = computed(() => [
      { "occ-label--bold": props.bold },
      { "occ-label--required": props.required },
      props.color ? `occ-label__color--${props.color}` : "",
      props.size ? `occ-label__size--${props.size}` : "",
      !props.required && props.background
        ? `occ-label__background--${props.background}`
        : ""
    ]);

    return { classes };
  }
});
